import {gql} from "@apollo/client";
import { client } from "graphql/client";

// 创建客服CS角色
export const CREATE_ACCOUNT_CS = gql`
    mutation CreateAccountCS($input: AccountCSInput!) {
        createAccountCS(input: $input)
    }
`;

// 更新客服CS角色
export const UPDATE_ACCOUNT_CS = gql`
    mutation UpdateAccountCS($input: AccountCSInput!) {
        updateAccountCS(input: $input)
    }
`;

export interface AccountCSInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    role: string;
}

export const createAccountCS = async (input: AccountCSInput): Promise<boolean> => {
        const {data} = await client.mutate({
            mutation: CREATE_ACCOUNT_CS,
            variables: {input}
        });
        return data.createAccountCS;
};

export const updateAccountCS = async (input: AccountCSInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_CS,
        variables: {input}
    });
    return data.updateAccountCS;
};

